// Location coordinates for Rogaland region
export const locationCoordinates = {
  // P02 Rogaland locations - spread across the fjord area
  'Toftøy': { lat: 59.270767, lng: 5.691433 },
  'Toftoy': { lat: 59.270767, lng: 5.691433 },
  'Føresvik': { lat: 59.249767, lng: 5.438233 },
  'Foresvik': { lat: 59.249767, lng: 5.438233 },
  'Rosshl.': { lat: 59.051467, lng: 5.708867 },
  'Rosshl': { lat: 59.051467, lng: 5.708867 },
  'Høgsfj.': { lat: 58.95365, lng: 5.96495 },
  'Høgsfj': { lat: 58.95365, lng: 5.96495 },
  'Hogsfj': { lat: 58.95365, lng: 5.96495 },
  'Finnøyfj.': { lat: 59.139017, lng: 5.86905 },
  'Finnøyfj': { lat: 59.139017, lng: 5.86905 },
  'Finnoyfj': { lat: 59.139017, lng: 5.86905 },
  'Årdalsfj.': { lat: 59.133917, lng: 6.040017 },
  'Årdalsfj': { lat: 59.133917, lng: 6.040017 },
  'Ardalsfj': { lat: 59.133917, lng: 6.040017 },
  'Jøsenfj.': { lat: 59.2746, lng: 6.244283 },
  'Jøsenfj': { lat: 59.2746, lng: 6.244283 },
  'Josenfj': { lat: 59.2746, lng: 6.244283 },
  'Erfj.': { lat: 59.311383, lng: 6.151933 },
  'Erfj': { lat: 59.311383, lng: 6.151933 },
  'Jelsa': { lat: 59.365433, lng: 6.01545 },
  'Vindafj.': { lat: 59.460917, lng: 5.950133 },
  'Vindafj': { lat: 59.460917, lng: 5.950133 },
  'Rott': { lat: 58.953383, lng: 5.51905 },
  'Boknafj.': { lat: 59.150617, lng: 5.51545 },
  'Boknafj': { lat: 59.150617, lng: 5.51545 },
  'Hj.sund': { lat: 59.320000, lng: 5.720000 },
  'Hjsund': { lat: 59.320000, lng: 5.720000 },
  'Kvitsøy': { lat: 59.065000, lng: 5.420000 },
  'Kvitsoy': { lat: 59.065000, lng: 5.420000 },
  'Nedstrand': { lat: 59.304000, lng: 5.745000 },
  'Sjernarøy': { lat: 59.138000, lng: 5.698000 },
  'Sjernaroy': { lat: 59.138000, lng: 5.698000 },
  'Ombo': { lat: 59.147000, lng: 5.985000 },
  'Fister': { lat: 59.267000, lng: 6.010000 },
  'Hjelmeland': { lat: 59.235000, lng: 6.185000 },
  'Tau': { lat: 59.065000, lng: 5.918000 },
  'Jørpeland': { lat: 59.020000, lng: 6.050000 },
  'Jorpeland': { lat: 59.020000, lng: 6.050000 }
};

// Chart colors
export const CHART_COLORS = ['#0d9488', '#14b8a6', '#2dd4bf', '#5eead4', '#99f6e4', '#0ea5e9', '#06b6d4'];

// Risk configuration
export const riskConfig = {
  low: { 
    color: '#10b981', 
    bgColor: 'bg-emerald-500',
    lightBg: 'bg-emerald-50',
    textColor: 'text-emerald-700',
    label: 'Grøn' 
  },
  medium: { 
    color: '#f59e0b', 
    bgColor: 'bg-amber-500',
    lightBg: 'bg-amber-50',
    textColor: 'text-amber-700',
    label: 'Gul' 
  },
  high: { 
    color: '#ef4444', 
    bgColor: 'bg-red-500',
    lightBg: 'bg-red-50',
    textColor: 'text-red-700',
    label: 'Raud' 
  }
};

/**
 * Get coordinates for a location name
 */
export function getLocationCoordinates(locationName, index = 0) {
  // Extract the actual location name (after " - " if present)
  const cleanName = locationName.includes(' - ') 
    ? locationName.split(' - ')[1] 
    : locationName;
  
  // Try exact match first
  if (locationCoordinates[cleanName]) {
    return locationCoordinates[cleanName];
  }
  
  // Try to find partial match (case insensitive, ignoring dots)
  const cleanNameLower = cleanName.toLowerCase().replace(/[.]/g, '');
  for (const [key, coords] of Object.entries(locationCoordinates)) {
    const keyLower = key.toLowerCase().replace(/[.]/g, '');
    if (cleanNameLower.includes(keyLower) || keyLower.includes(cleanNameLower)) {
      return coords;
    }
  }
  
  // Generate coordinates within Rogaland fjord area if no match found
  const baseLat = 59.15;
  const baseLng = 5.85;
  const angle = (index * 137.508) * (Math.PI / 180);
  const radius = 0.08 + (index * 0.015);
  return {
    lat: baseLat + radius * Math.cos(angle),
    lng: baseLng + radius * Math.sin(angle) * 1.5
  };
}

/**
 * Get risk level based on biomass
 */
export function getRiskLevel(biomass) {
  if (biomass > 15) return 'high';
  if (biomass > 8) return 'medium';
  return 'low';
}

/**
 * Format date to Norwegian locale
 */
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('nb-NO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
